  









// BLOG RIGHT COL HEIGHTS / POS *****************************************         
$(window).on("resize", function() {   
    let blogContentHeight = $("#BlogContentSectionText").outerHeight(); 
    $("#BlogContentSectionRightCol").css({"height": blogContentHeight });
    $("#BlogContentSectionRightCol h1").css({"width": blogContentHeight, "left": "calc(50% - " + blogContentHeight / 2 + "px)" });  
}).resize();









